// INFORMES requests
export const INFORMES_LIST = "INFORMES_LIST";
export const INFORMES_LISTA = "INFORMES_LISTA";
export const INFORMES_CREATE = "INFORMES_CREATE";
export const INFORMES_FILTER = "INFORMES_FILTER";
export const INFORMES_UPDATE = "INFORMES_UPDATE";
export const INFORMES_DELETE = "INFORMES_DELETE";
export const INFORMES_READ = "INFORMES_READ";

// INFORMES success
export const INFORMES_LIST_SUCCESS = "INFORMES_LIST_SUCCESS";
export const INFORMES_CREATE_SUCCESS = "INFORMES_CREATE_SUCCESS";
export const INFORMES_UPDATE_SUCCESS = "INFORMES_UPDATE_SUCCESS";
export const INFORMES_DELETE_SUCCESS = "INFORMES_DELETE_SUCCESS";
export const INFORMES_READ_SUCCESS = "INFORMES_READ_SUCCESS";

// INFORMES failed
export const INFORMES_REQUEST_FAILED = "INFORMES_REQUEST_FAILED";
